<template>
  <div>
    <base-header type="gradient-default" class="pb-7 pt-5 pt-md-8">

    </base-header>
    <!--Charts-->
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-3 col-md-4 col-sm-12">
          <card header-classes="bg-transparent pb-1 pt-2" body-classes="divImgDiario"
                footer-classes="divFooterDiario">
            <div slot="header" class="row align-items-center">
              <div class="col text-center">
                <h5 class="h2 mb-0">Útima Edição</h5>
              </div>
            </div>
            <div class="col-md-12 text-center" style="padding: 0">
              <div v-if="!loandImgDiario">
                <content-loader
                    :width=210
                    :height=295
                    :speed=2
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb">
                  <rect x="0" y="0" rx="0" ry="0" width="210" height="300"/>
                </content-loader>
              </div>
              <a v-if="!entidade.ent_modelo_diario" @click="dowload(diarioDestaque)" href="#">
                <img alt="Diário" @load="onLoadHandler()" v-if="diarioDestaque.dia_codigo" v-show="loandImgDiario"
                     v-bind:src="baseUrl+'image/preview/'+diarioDestaque.dia_codigo+'.png'"
                     style="width: 100%">
              </a>
              <a v-else @click="dowload(diarioDestaque)" href="#">
                <img alt="Diário" @load="onLoadHandler()" v-if="diarioDestaque.dia_codigo" v-show="loandImgDiario"
                     v-bind:src="baseUrl+'image/preview/'+diarioDestaque.dia_codigo+'_1.png'"
                     style="width: 100%">
              </a>
            </div>
            <div slot="footer" class="align-items-center">
              <div class="row text-center">
                <div class="col-6">
                  <base-button type="danger" @click="dowload(diarioDestaque)" size="sm">Baixar PDF
                  </base-button>
                </div>
                <div class="col-6">
                  <base-button type="primary" @click="dowload(diarioDestaque, 'HTML')" size="sm">
                    Baixar HTML
                  </base-button>
                </div>
              </div>
              <div class="row mt-2">
                <router-link v-if="diarioDestaque.dia_numero" ref="link"
                             class="btn btn-block btn-outline-default btn-sm"
                             :to="{name: 'diario', params: { dia_numero: diarioDestaque.dia_numero }}">
                  <i class="far fa-file-alt"></i> Diário em detalhe
                </router-link>
              </div>
            </div>
          </card>
        </div>
        <div class="col-xl-9 col-md-8 col-sm-12 mb-5 mb-xl-0 mt-5">
          <ultimos-diarios :loander="loandTablediarios" :diarios="diarios"></ultimos-diarios>
          <div class="row mt-3">
            <div class="offset-1 col-md-10">
              <base-button block v-show="!loandMaisDiarios && diarios.length < entidade.total_diario"
                           size="sm" @click="maisDiarios" type="default">
                <i class="fas fa-plus"></i>
                Mais diários
              </base-button>
              <div v-show="diarios.length >= entidade.total_diario" class="text-center">
                Sem mais diários
              </div>
              <div v-show="loandMaisDiarios" class="text-center">
                <i class="fas fa-spinner fa-pulse"></i> Carregando...
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End charts-->
    </div>
  </div>
</template>
<script>
import {ContentLoader} from "vue-content-loader"
import {dowloadDiario} from "@/plugins/webdom";
import {getBaseURL} from "../config"
import UltimosDiarios from './Dashboard/UltimosDiarios';
import {getDiarios} from '@/api/inicio'

export default {
  components: {
    ContentLoader,
    UltimosDiarios
  },
  data() {
    return {
      baseUrl: getBaseURL(),
      loandImgDiario: false,
      loandTablediarios: false,
      loandMaisDiarios: false,
      filter: {
        page: 1,
        limit: 5
      },
      diarioDestaque: {},
      diarios: []
    };
  },
  methods: {
    onLoadHandler: function () {
      this.loandImgDiario = true;
    },
    listDiarios() {
      this.loandTablediarios = true;
      getDiarios(this.filter).then(response => {
        if (response.status) {
          this.diarios = response.data;
          this.diarioDestaque = this.diarios[0];
        }
      }).catch(error => {
        //console.log(error);
      }).finally(finalit => {
        this.loandTablediarios = false;
      })
    },
    maisDiarios() {
      this.loandMaisDiarios = true;
      this.filter.page += 1;
      getDiarios(this.filter).then(response => {
        if (response.status) {
          response.data.forEach((value, index) => {
            this.diarios.push(value)
          });
        }
      }).catch(error => {
        //console.log(error);
      }).finally(finalit => {
        this.loandMaisDiarios = false;
      })
    },
    dowload(diario, tipo = 'PDF') {
      dowloadDiario(diario, tipo)
    }
  },
  computed: {
    entidade() {
      return this.$store.getters.entidade;
    }
  },
  mounted() {

  },
  created() {
    this.listDiarios();
  }
};
</script>
<style>
.divImgDiario {
  padding: 0;
}

.divFooterDiario {
  padding: 0.5rem 1.5rem;
}

.text-pequeno {
  font-size: 10px;
}
</style>
